// extracted by mini-css-extract-plugin
export var formContainer = "_k2-0";
export var message = "_k2-1";